var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 212,
    viewBox: "0 0 182 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4721_3973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.22 199.971L173.208 178.88L172.89 170.531H14.7081L8.11719 185.031V191.183C8.11719 196.455 12.5111 199.971 16.0263 199.971H161.22Z",
    fill: "url(#paint0_linear_4721_3973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8044 4C24.8044 4 24.8044 6.59626 24.8044 8.05416L24.8139 177.301C24.8139 177.845 24.8139 178.879 24.8139 178.879H22.6167C17.7536 178.879 10.7531 182.833 8.13156 188.545L8.13156 103.291C8.13156 101.743 8.13091 83.8955 8.13091 83.8955L8.11732 76.8951V57.1235L8.13156 55.0665V47.0031V44.6465L8.00041 33.8351L8 29.9659C8 29.9659 8.00041 27.5933 8.00041 26.2901V19.3981C8.00041 18.2098 8.20801 9.5 17.708 6L21.208 5L24.7664 4H24.8044Z",
    fill: "url(#paint1_linear_4721_3973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.208 4.29536V8.39394V17.6212V19.8182V21.1364V22.4545V25.1659V27.2879C173.208 27.2879 173.218 118.673 173.208 120.725V147.319C173.198 147.604 173.208 159.318 173.208 159.56V172.724V178.879H24.814L24.7832 10.2883C24.7833 10.3113 24.7835 8.41645 24.7835 8.41645L24.7832 7.00196V5.14086L24.7839 4.56821V4.31787L24.7832 4C41.0249 4.04751 156.966 4.24785 173.208 4.29536Z",
    fill: "url(#paint2_linear_4721_3973)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9355,
    y: 33,
    width: 91.3939,
    height: 34.2727,
    rx: 8.5,
    fill: "url(#paint3_linear_4721_3973)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9355,
    y: 85.7266,
    width: 91.3939,
    height: 4.39394,
    rx: 2.19697,
    fill: "url(#paint4_linear_4721_3973)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9355,
    y: 101.545,
    width: 91.3939,
    height: 3.51515,
    rx: 1.75758,
    fill: "url(#paint5_linear_4721_3973)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9355,
    y: 116.484,
    width: 91.3939,
    height: 4.39394,
    rx: 2.19697,
    fill: "url(#paint6_linear_4721_3973)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4721_3973",
    x: -7.79199,
    y: 0,
    width: 190,
    height: 219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4721_3973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4721_3973",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4721_3973",
    x1: 23.208,
    y1: 196,
    x2: 173.208,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CBA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4721_3973",
    x1: 25.7037,
    y1: 93.0202,
    x2: 9.00682,
    y2: 92.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CBA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4721_3973",
    x1: 172.928,
    y1: 91.529,
    x2: 24.8304,
    y2: 91.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CBA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4721_3973",
    x1: 52.9355,
    y1: 50.1364,
    x2: 144.329,
    y2: 50.1364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99DCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4721_3973",
    x1: 52.9355,
    y1: 87.9235,
    x2: 144.329,
    y2: 87.9235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99DCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4721_3973",
    x1: 52.9355,
    y1: 103.302,
    x2: 144.329,
    y2: 103.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99DCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4721_3973",
    x1: 52.9355,
    y1: 118.681,
    x2: 144.329,
    y2: 118.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99DCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalBook);
export default __webpack_public_path__ + "static/media/journal-book.af6507423778f222425f9c799d02271e.svg";
export { ForwardRef as ReactComponent };